// @ts-check
/**
 * Widths an image's thumbnail can be requested to have.
 * @enum {import('@/types/app').AllowedThumbnailWidth}
 */
const allowedThumbnailWidths = /**
	 * @type {import('@/types/app').AllowedThumbnailWidthConst}
	 */({
		56: 56,
		250: 250,
		300: 300,
		500: 500,
		600: 600,
		1920: 1920
	});

/**
 * Using the older export syntax so that JEST won't be confused.
 */
module.exports = { allowedThumbnailWidths };
